module.exports = __webpack_public_path__ + "img/pougheon.b338feac.jpg";